import SuppliedBy from 'components/suppliedBy/SuppliedBy';
import React, { PureComponent } from 'react';

import withLicenseNoteContext from 'hoc/withLicenseNoteContext';
import License from 'types/License';

import { FormattedMessage } from 'react-intl';
import { Footer, FooterSupplied, TextContainer } from './Footer.styles';
import BlueMediaCardDataProcessingNote from './notes/BlueMediaCardDataProcessingNote';
import StandardDataProcessingMbankNote from './notes/StandardDataProcessingMbankNote';
import StandardDataProcessingMelementsNote from './notes/StandardDataProcessingMelementsNote';
import { availablePmpt } from '../../consts';
import withLocaleContext from '../../hoc/withLocaleContext';

class FooterComponent extends PureComponent<Partial<ILicenseNoteContext>> {
  render() {
    const { isCardEnabled, license, pmpt, formatMessage } = this.props;

    return (
      <Footer className="footer__container">
        {!!license && (
          <div>
            <FooterSupplied>
              <SuppliedBy license={(license as License).toLowerCase()} />
            </FooterSupplied>
            {license === License.MELEMENTS ? (
              <StandardDataProcessingMelementsNote />
            ) : (
              <StandardDataProcessingMbankNote />
            )}

            {isCardEnabled && pmpt === availablePmpt.BM && <BlueMediaCardDataProcessingNote />}

            {license === License.MELEMENTS && (
              <TextContainer className="knf-notice">
                <FormattedMessage id="footer.melements.knfText" />
                <a
                  href={formatMessage && formatMessage({ id: `footer.melements.knfLink` })}
                  target="_blank"
                  rel="noreferrer"
                >
                  <FormattedMessage id="footer.melements.knfLinkText" />
                </a>
              </TextContainer>
            )}
          </div>
        )}
      </Footer>
    );
  }
}

export default withLocaleContext(withLicenseNoteContext(FooterComponent));
